// EmailInput.jsx
import React, { useState } from 'react';
import { useFormikContext } from 'formik';
import styles from './EmailInput.module.scss';
import userIcon from '../../../../../assets/Imagess/usreprofileicon.svg';
import { IconWrapper } from '../../../../Atoms/icons/Icon';

const EmailInput = ({ name, label, errors }) => {
  const { values, setFieldValue } = useFormikContext();
  const [inputValue, setInputValue] = useState('');

  const handleAddEmail = () => {
    const email = inputValue.trim();
    if (email && validateEmail(email)) {
      setFieldValue(name, [...(values[name] || []), email]);
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddEmail();
    }
  };

  const handleBlur = () => {
    handleAddEmail();
  };

  const handleRemove = (index) => {
    const updated = [...values[name]];
    updated.splice(index, 1);
    setFieldValue(name, updated);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  return (
    <div className={styles.emails}>
      <span className={styles.label}>{label}:</span>
      <div className={styles.emailContainer}>
        {values[name]?.map((email, index) => (
          <div key={index} className={styles.emailChip}>
            <img src={userIcon} alt='user' />
            <span>{email}</span>
            <button
              type='button'
              onClick={() => handleRemove(index)}
              className={styles.removeBtn}
            >
              <IconWrapper icon='close' size={12} />
            </button>
          </div>
        ))}
        <input
          type='email'
          className={`${styles.input} ${errors ? styles.error : ''}`}
          placeholder='Add recipient'
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};

export default EmailInput;
